var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crad-bg"},[_c('p',[_vm._v("账户余额：")]),_c('p',[_c('span',{class:[_vm.balance < 100 ? 'red' : ''],staticStyle:{"font-size":"40px"}},[_vm._v(_vm._s(_vm.balance))]),_vm._v("元\n  ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ps"},[_vm._v("注：账户余额可用于购买任意类型工资条，充值送工资条。")])])
}]

export { render, staticRenderFns }